export default __webpack_public_path__ + "static/bgContact-ce3e1d7b213006efa1db2951432c7495.png";